export default {
  URL_DOES_NOT_HAVE_PROTOCOL: "آدرس سایت بدون http:// یا https:// هست.",
  URL_HAS_FORWARD_SLASH: "آدرس سایت دارای  / است.",
  URL_IS_INVALID: "آدرس سایت نامعبتر است.",
};
